<ng-container *ngIf="(authState$ | async)?.type !== PendingState">
  <section *ngIf="!(isLoggedIn$ | async)" class="explanation" test-target="price-type-explanation">
    <div class="explanation__container">
      <div class="price-type-explanation__desktop" fxLayout="row" fxLayoutAlign="center start">
        <div class="price-type-explanation__desktop__image">
          <img [src]="confirmationImgUrl" width="133" height="85" alt="explanation">
        </div>

        <p class="price-type-explanation__desktop__message">
          {{ 'CORE.ALL_PAGES.PRICE_SWITCH.EXPLANATION_MESSAGE_1' | translate }}
          {{ 'CORE.ALL_PAGES.PRICE_SWITCH.EXPLANATION_MESSAGE_2' | translate }}
        </p>

        <button
          mm-button
          color="ghost-mute"
          class="price-type-explanation__close-button"
          (click)="closePriceTypeExplanation()">
          <mm-icon name="close-search" class="price-type-explanation__close-icon"></mm-icon>
        </button>
      </div>
    </div>
  </section>
</ng-container>
